import React from 'react';
import { useParams } from 'react-router-dom';

const CheckOut = () => {
    // const { checkout } = useParams()
    return (
        <div className='container mt-5 text-center ' style={{ color: 'RGB(220,77,1)', marginBottom: '25rem' }}>
            <h3>Checkout every info with details </h3>
        </div>
    );
};

export default CheckOut;